<script lang="ts">
	// Genuine shadcn-svelte Input (CLI-fetched), RESTYLED to price-check tokens.
	// Keeps the stock file/non-file split + data-slot; shadcn's --input/--ring vars
	// and arbitrary values are swapped for our semantic utilities + scale presets.
	// NO arbitrary `[..]` values.
	import type { HTMLInputAttributes, HTMLInputTypeAttribute } from "svelte/elements";
	import { cn, type WithElementRef } from "../../../utils.js";

	type InputType = Exclude<HTMLInputTypeAttribute, "file">;

	type Props = WithElementRef<
		Omit<HTMLInputAttributes, "type"> &
			({ type: "file"; files?: FileList } | { type?: InputType; files?: undefined })
	>;

	let {
		ref = $bindable(null),
		value = $bindable(),
		type,
		files = $bindable(),
		class: className,
		"data-slot": dataSlot = "input",
		...restProps
	}: Props = $props();

	const base =
		"h-9 w-full min-w-0 rounded-md border border-border bg-surface px-3 py-2 text-sm text-ink shadow-sm transition-colors duration-100 outline-none placeholder:text-muted focus:border-brand focus:ring-2 focus:ring-brand disabled:cursor-default disabled:opacity-55 file:mr-3 file:inline-flex file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-ink";
</script>

{#if type === "file"}
	<input
		bind:this={ref}
		data-slot={dataSlot}
		class={cn(base, className)}
		type="file"
		bind:files
		bind:value
		{...restProps}
	/>
{:else}
	<input
		bind:this={ref}
		data-slot={dataSlot}
		class={cn(base, className)}
		{type}
		bind:value
		{...restProps}
	/>
{/if}
